import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { TextInput, Select, DatePicker, Button, Modal } from 'advenio-components'
import { Form } from 'formsy-react'
import moment from 'moment'

const Container = styled.div`
  padding:24px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
const InputContainer = styled.div`
  flex:1;
  &:first-of-type{
    margin: 0 8px 0 0;
  }
  &:last-of-type{
    margin: 0 0 0 8px;
  }
`
const Row = styled.div`
  display: flex;
  justify-content: space-between;
`
const SmallButton = props => <Button small {...props} />

class DeleteStudentModal extends Component {
  state = {
    x: 0,
    disenrollment: [],
  }

  componentWillReceiveProps = (nextProps) => {
    const { disenrollmentCategories } = nextProps

    if (disenrollmentCategories) {
      const newDisenrollmentCategories = disenrollmentCategories.map(category => (
        {
          label: category.name,
          id: category.id,
          value: category.id,
        }
      ))

      this.setState({ disenrollment: newDisenrollmentCategories })
    }
  }

  handleSubmit = data => this.props.onDeleteStudent(data)

  render() {
    const { open, onClose, loading } = this.props

    return (
      <Modal
        isOpened={open}
        onClose={onClose}
        headerTitle="Dar de baja estudiante"
        statePath="classrooms"
        actionType="sendRequest"
        typePrefix="CLASSROOMS"
      >
        <Container>
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <InputContainer>
                <Select
                  name="category_id"
                  label="Motivo"
                  options={this.state.disenrollment}
                  value={1}
                  required
                />
              </InputContainer>
              {/*<InputContainer>*/}
              {/*  <DatePicker*/}
              {/*    name="disenrolled_on"*/}
              {/*    label="Fecha de baja"*/}
              {/*    value={moment().format('YYYY-MM-DD')}*/}
              {/*    disableAfterToday*/}
              {/*  />*/}
              {/*</InputContainer>*/}
            </Row>
            <TextInput
              name="reason"
              label="Comentarios"
              textarea
              required
            />
            <Row>
              <InputContainer>
                <TextInput
                  name="retention_description"
                  label="¿Qué hicímos para retenerlo?"
                  textarea
                  required
                />
              </InputContainer>
              <InputContainer>
                <TextInput
                  name="prevention_description"
                  label="¿Qué podemos hacer para evitar que se vayan más?"
                  textarea
                  required
                />
              </InputContainer>
            </Row>
            <ButtonContainer>
              <SmallButton>Cancelar</SmallButton>
              <SmallButton
                danger
                type="submit"
                loading={loading}
              >
                Dar de baja
              </SmallButton>
            </ButtonContainer>
          </Form>
        </Container>
      </Modal>
    )
  }
}

DeleteStudentModal.propTypes = {
  /** Loading flag */
  loading: PropTypes.bool.isRequired,
  /** Flag marking if the modal should be displayed */
  open: PropTypes.bool.isRequired,
  /** Callback function to close the modal */
  onClose: PropTypes.func.isRequired,
  /** Callback function to disenroll this student */
  onDeleteStudent: PropTypes.func.isRequired,
}

export default DeleteStudentModal



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/DeleteStudentModal.jsx